const OnboardingStep = Object.freeze({
  START: 'start',
  PREFERRED_NAME: 'preferred_name',
  WELCOME: 'welcome',
  DNA_YOUR_PACE: 'dna_your-pace',
  DNA_YOUR_STAY: 'dna_your-stay',
  DNA_YOUR_SANCTUARY: 'dna_your-sanctuary',
  DNA_YOUR_TABLE: 'dna_your-table',
  DNA_YOUR_FOOD_PREFERENCES: 'dna_your-food-preferences',
  DNA_YOUR_WORLD: 'dna_your-world',
  DNA_YOUR_PLANS: 'dna_your-plans',
  DNA_YOUR_SPENDING: 'dna_your-spending',
  DNA_YOUR_SPLURGES: 'dna_your-splurges',
  DNA_YOUR_TRIP: 'dna_your-trip',
  DNA_YOUR_DEFAULTS: 'dna_your-defaults',
  DNA_YOUR_ACCESSIBILITY: 'dna_your-accessibility',
  DNA_ANYTHING_ELSE: 'dna_anything-else',
  DNA_CONFIRMATION: 'dna-confirmation',
  TRIP_CREATION: 'trip-creation',
  FINISHED: 'finished',

  // Legacy values retained so existing users can still resume.
  DNA_YOUR_STANDARD: 'dna_your-standard',
  DNA_YOUR_LOCATION: 'dna_your-location',
  DNA_YOUR_LIMITS: 'dna_your-limits',
} as const);

export type OnboardingStep =
  (typeof OnboardingStep)[keyof typeof OnboardingStep];

export const allOnboardingSteps: [OnboardingStep, ...OnboardingStep[]] =
  Object.values(OnboardingStep) as [OnboardingStep, ...OnboardingStep[]];

export default OnboardingStep;
